// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import Linkify from 'react-linkify'

// data
import {
    defaultReduxState,
} from 'data'

// actions
import {
    reduxSalesTicketSite,
} from 'data/site/redux/sales/mo_actions'

// pages
import {
    Free816Site,
    Sales816Site,
} from 'pages'

// serializers
import {
    MainIdNameSerializer,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template816SiteSerializer,
} from 'serializers/site'

// services
import {
    getTextSite,
} from 'services'

// props
type TemplateBlock816SiteProps = {
    blockId: string
    detailId: string | undefined
    content: Template816SiteSerializer | undefined
    isEditHovered: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentStyles?: any
    styles: any
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock816Site: React.FC<TemplateBlock816SiteProps> = React.memo(({
    blockId,
    content,
    detailId,
    isEditHovered,
    mainParentId,
    object,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    const [text, setText] = useState<{
        normal: string
        rich: string | undefined,
    }>()

    useEffect(() => {
        setText({
            normal: getTextSite(content?.text, reduxModalSite, reduxText),
            // @ts-ignore
            rich: content?.text?.is_rich ? content.text?.value : content?.text_html,
        })
    }, [
        content?.text,
        content?.text_html,
        reduxModalSite,
    ])

    // Reset ticketData when content.id changes
    useEffect(() => {
        dispatch(reduxSalesTicketSite({
            variants: {},
            totalValue: 0,
            totalQty: 0,
        }))
    }, [
        content?.id,
        dispatch,
    ])

    if (content?.is_full) {
        const isRichText = (content?.text_short_mode === 2 && content?.text_html) || content?.text?.is_rich
        return (
            <div
                id={blockId}
                className={`template-block-816${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
            >
                <div className={`t-816-block ${deviceType}`}>
                    <div className={`t-816-event-full ${deviceType}`}>
                        <div className="t-816-event-full-content">
                            <div className="t-816-event-full-text">
                                {isRichText
                                    ? (
                                        <Linkify componentDecorator={(decoratedHref, decoratedText, key) => <a key={key} href={decoratedHref} target='blank'>{decoratedText}</a>}>
                                            <div dangerouslySetInnerHTML={{ __html: content?.text_html! || text?.rich! }} />
                                        </Linkify>
                                    ) : (
                                        text?.normal || reduxText[11062]
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (content?.show_free_subscription_form) {
        return (
            <Free816Site
                blockId={blockId}
                content={content}
                detailId={detailId}
                isEditHovered={isEditHovered}
                mainParentId={mainParentId}
                object={object}
                parentArray={parentArray}
                parentStyles={parentStyles}
                styles={styles}
                stylesEdit={stylesEdit}
            />
        )
    }

    return (
        <Sales816Site
            blockId={blockId}
            content={content}
            isEditHovered={isEditHovered}
            mainParentId={mainParentId}
            object={object}
            parentArray={parentArray}
            parentStyles={parentStyles}
            styles={styles}
            stylesEdit={stylesEdit}
        />
    )
})
